<h3>Ficha de empleado</h3>

<div class="flex flex-row gap-4 h-full">

  <div class="btn btn-neutral-outline avatar !w-[6.6rem] !h-[6.6rem] overflow-hidden shrink-0">
    @if (isLoadingAvatar) {
      <div class="h-full w-full skeleton skeleton-rect rounded-full"></div>
    } @else if (avatarSrc()) {
      <img [src]="avatarSrc()" alt="Avatar" class="h-full w-full object-cover rounded-full block" (error)="handleAvatarError($event)"/>
    }
  </div>

  <div class="flex flex-col gap-1 w-full">
    <h6 class="pb-1">{{ detail?.name || employee?.name || 'Empleado' }}</h6>
    <span class="cd-text-b3 text-neutral-600">{{ detail?.group || employee?.group || 'Sin grupo' }}</span>
  <div class="flex flex-row flex-wrap gap-2 mr-auto">
    <span class="cd-text-b3 text-neutral-600">{{ courses.length }} Cursos</span>
    <span class="cd-text-b3 text-neutral-600">{{ policies.length }} Políticas</span>
  </div>
  </div>

  <div class="flex flex-row flex-wrap gap-2 ml-auto mb-auto">
    <button (click)="edit.emit()"
            class="btn btn-primary flex flex-row gap-2 items-center min-w-[8rem]">
      <span class="lg:block cd-text-md truncate capitalize">Editar datos</span>
    </button>

    @if (canInviteAccess || isInvitingAccess) {
      <button
        (click)="invitePlatformAccess()"
        [disabled]="!canInviteAccess"
        class="btn btn-primary-soft flex flex-row gap-2 items-center min-w-[11rem]"
        type="button">
        <img alt="Invitar acceso" class="filter-primary-600 h-4" src="/assets/icons/feather/send.svg">
        <span class="cd-text-md truncate">
          {{ isInvitingAccess ? 'Generando...' : 'Invitar a la plataforma' }}
        </span>
      </button>
    }
  </div>

</div>

<div class="flex gap-2 flex-row flex-wrap">

  <div class="outline primary truncate !py-1 !px-2 cd-text-b4 text-center flex flex-row gap-2">
    <img alt="Icon" class="filter-primary-600 h-4" src="/assets/icons/feather/calendar.svg">
    <span class="truncate">{{ detail?.since_at || employee?.since_at || '-' }}</span>
  </div>

  <div class="outline primary truncate !py-1 !px-2 cd-text-b4 text-center flex flex-row gap-2">
    <img alt="Icon" class="filter-primary-600 h-4" src="/assets/icons/feather/mail.svg">
    <span class="truncate">{{ detail?.email || employee?.email || '-' }}</span>
  </div>

  <div class="outline primary truncate !py-1 !px-2 cd-text-b4 text-center flex flex-row gap-2">
    <img alt="Icon" class="filter-primary-600 h-4" src="/assets/icons/feather/user-check.svg">
    @if (isLoadingAccess) {
      <span class="truncate">Cargando acceso...</span>
    } @else {
      <span class="truncate">{{ resolveAccessLabel(accessStatus) }}</span>
    }
  </div>

  @if (accessRoleLabel) {
    <div class="outline warning truncate !py-1 !px-2 cd-text-b4 text-center flex flex-row gap-2">
      <img alt="Icon" class="h-4 filter-yellow-500" src="/assets/icons/feather/shield.svg">
      <span class="truncate">{{ accessRoleLabel }}</span>
    </div>
  }
  @if ((detail?.metadata?.activityKey || employee?.metadata?.activityKey) === 'yes') {
    <div class="outline primary truncate !py-1 !px-2 cd-text-b4 text-center flex flex-row gap-2">
      <img alt="Icon" class="filter-primary-600 h-4" src="/assets/icons/feather/key.svg">
      <span class="truncate">Actividad clave para la empresa</span>
    </div>
  }

  @if ((detail?.metadata?.sensitiveData || employee?.metadata?.sensitiveData) === 'yes') {
    <div class="outline primary truncate !py-1 !px-2 cd-text-b4 text-center flex flex-row gap-2">
      <img alt="Icon" class="filter-primary-600 h-4" src="/assets/icons/feather/database.svg">
      <span class="truncate">Tiene datos sensibles</span>
    </div>
  }

  @if ((detail?.metadata?.cashControl || employee?.metadata?.cashControl) === 'yes') {
    <div class="outline primary truncate !py-1 !px-2 cd-text-b4 text-center flex flex-row gap-2">
      <img alt="Icon" class="filter-primary-600 h-4" src="/assets/icons/feather/dollar-sign.svg">
      <span class="truncate">Acceso a control de caja</span>
    </div>
  }

</div>

@if (accessFeedback) {
  <div class="employee-access-feedback employee-access-feedback-success">
    <span class="cd-text-b4">{{ accessFeedback }}</span>
  </div>
}

@if (accessError) {
  <div class="employee-access-feedback employee-access-feedback-error">
    <span class="cd-text-b4">{{ accessError }}</span>
  </div>
}

<div class="flex flex-row flex-wrap gap-3 items-center">
  @if (accessStatus === 'pending') {
    <div class="flex flex-col gap-2">
      <span class="cd-text-b4 text-neutral-600">La invitación ya fue enviada y sigue pendiente de aceptación para esta empresa.</span>

      @if (pendingAccessInvitation) {
        <div class="employee-access-links">
          <div class="employee-access-link-row">
            <span class="employee-access-link-label">Enlace</span>
            <a [href]="accessInvitationManagementUrl" class="employee-access-link" target="_blank" rel="noopener noreferrer">{{ accessInvitationManagementUrl }}</a>
            <button (click)="copyInvitationLink()" class="btn btn-primary-text !py-0 !px-0" type="button">Copiar</button>
          </div>
        </div>
      }
    </div>
  }

</div>

<core-tabs [config]="[
    { slug: 'courses', label: 'Cursos asociados', template: coursesTabTpl},
    { slug: 'policies', label: 'Aceptación de políticas', template: policiesTabTpl},
    { slug: 'attachments', label: 'Archivos adjuntos', template: attachmentsTabTpl},
    { slug: 'notes', label: 'Notas', template: notesTabTpl}]"/>

<ng-template #coursesTabTpl let-slug>
  @if (isLoadingCourses) {
    <div class="flex flex-col gap-2">
      @for (item of tabSkeletonItems; track item) {
        <div class="flex flex-row justify-between items-center bg-white rounded-xl p-3 shadow-e1">
          <div class="flex flex-col gap-2 flex-1 min-w-0">
            <div class="h-4 w-2/3 skeleton skeleton-rect rounded-md"></div>
            <div class="h-3 w-24 skeleton skeleton-rect rounded-md"></div>
          </div>
          <div class="h-4 w-12 skeleton skeleton-rect rounded-md shrink-0"></div>
        </div>
      }
    </div>
  } @else if (coursesError) {
    <span class="cd-text-b4 text-error-600">{{ coursesError }}</span>
  } @else if (courses.length) {
    <div class="flex flex-col gap-2">
      @for (course of courses; track course.id) {
        <div class="flex flex-row justify-between items-center bg-white rounded-xl p-3 shadow-e1">
          <div class="flex flex-col">
            <span class="cd-text-b3 font-medium">{{ course.name }}</span>
            <span class="cd-text-b5 text-neutral-500">{{ course.status || 'pendiente' }}</span>
          </div>
          <span class="cd-text-b4 text-neutral-600">{{ course.progress ?? 0 }}%</span>
        </div>
      }
    </div>
  } @else {
    <span class="cd-text-b4 text-neutral-500">Sin cursos asignados.</span>
  }
</ng-template>

<ng-template #policiesTabTpl let-slug>
  @if (isLoadingPolicies) {
    <div class="flex flex-col gap-2">
      @for (item of tabSkeletonItems; track item) {
        <div class="flex flex-row justify-between items-center bg-white rounded-xl p-3 shadow-e1">
          <div class="flex flex-col gap-2 flex-1 min-w-0">
            <div class="h-4 w-2/3 skeleton skeleton-rect rounded-md"></div>
            <div class="h-3 w-24 skeleton skeleton-rect rounded-md"></div>
          </div>
          <div class="h-4 w-20 skeleton skeleton-rect rounded-md shrink-0"></div>
        </div>
      }
    </div>
  } @else if (policiesError) {
    <span class="cd-text-b4 text-error-600">{{ policiesError }}</span>
  } @else if (policies.length) {
    <div class="flex flex-col gap-2">
      @for (policy of policies; track policy.id) {
        <div class="flex flex-row justify-between items-center bg-white rounded-xl p-3 shadow-e1">
          <div class="flex flex-col">
            <span class="cd-text-b3 font-medium">{{ policy.name }}</span>
            <span class="cd-text-b5 text-neutral-500">{{ policy.status || 'pendiente' }}</span>
          </div>
          <span class="cd-text-b4 text-neutral-600">{{ policy.acceptedAt || '-' }}</span>
        </div>
      }
    </div>
  } @else {
    <span class="cd-text-b4 text-neutral-500">Sin políticas asignadas.</span>
  }
</ng-template>

<ng-template #attachmentsTabTpl let-slug>
  @if (isLoadingDetail) {
    <div class="flex flex-col gap-2">
      @for (item of [1, 2, 3]; track item) {
        <div class="flex items-start gap-6 rounded-lg bg-neutral px-3 py-3">
          <div class="h-8 w-8 skeleton skeleton-rect rounded-md shrink-0"></div>
          <div class="flex flex-col gap-2 flex-1 min-w-0">
            <div class="h-4 w-3/4 skeleton skeleton-rect rounded-md"></div>
            <div class="h-3 w-24 skeleton skeleton-rect rounded-md"></div>
          </div>
          <div class="h-8 w-8 skeleton skeleton-rect rounded-md shrink-0"></div>
        </div>
      }
    </div>
  } @else if (attachmentsError) {
    <span class="cd-text-b4 text-error-600">{{ attachmentsError }}</span>
  } @else if (attachments.length) {
    <div class="flex flex-col gap-2">
      @for (file of attachments; track file.id) {
        <core-file-widget
          [badge]="isContractAttachment(file.fileName) ? 'Contrato' : ''"
          [fileName]="file.fileName"
          [fileSize]="((file.fileSize || 0) / 1024).toFixed(2) + ' KB'"
          [showRemove]="false"
          (download)="downloadAttachment(file)"/>
      }
    </div>
  } @else {
    <span class="cd-text-b4 text-neutral-500">Sin documentos adjuntos.</span>
  }
</ng-template>

<ng-template #notesTabTpl let-slug>
  <div class="flex items-center justify-center rounded-xl border border-dashed border-neutral-300 bg-white px-4 py-8">
    <span class="cd-text-b4 text-neutral-500">Este espacio quedará disponible cuando integremos las notas del empleado.</span>
  </div>
</ng-template>
